import { gql } from '@apollo/client'

export const GET_ACTIVITY_REPORTS_COUNTERS = gql`
  query GetActivityReportsCountersByRol($filters: countCategoryFilterInput) {
    getActivityReportsCountersByRol(filters: $filters) {
      category {
        total
        pending
        completed
        canceled
        averageCompleted
        tlajochat
        web
        app
      }
      subcategory {
        total
        pending
        completed
        canceled
        averageCompleted
        tlajochat
        web
        app
      }
    }
  }
`

export const GET_ACTIVITY_COMPARATIVE_REPORTS_COUNTERS = gql`
  query GetActivityComparativeReportsCounters(
    $filters: countCategoryFilterInputComparative
  ) {
    getActivityComparativeReportsCounters(filters: $filters) {
      category {
        app
        averageCompleted
        canceled
        completed
        pending
        tlajochat
        total
        web
      }
      subcategory {
        counters {
          app
          averageCompleted
          canceled
          completed
          pending
          tlajochat
          total
          web
        }
        name
      }
    }
  }
`

export const GET_ACTIVITY_REPORTS_COUNTERS_BY_ADMIN_MASTER = gql`
  query getActivityReportsCountersByAdminMasterMayor(
    $filters: countCategoryFilterInputAdminMasterMayor
  ) {
    getActivityReportsCountersByAdminMasterMayor(filters: $filters) {
      generated
      in_process
      resolved
      effectiveness
      generalPercentage
      tlajochat
      web
      app
      categories {
        id
        name
        percentage
        quantity
        resolved
        icon
        subcategories {
          name
          percentage
          quantity
          resolved
          icon
        }
      }
      counterByDateFilter {
        label
        generated
        in_process
        resolved
        effectiveness
        categories {
          id
          name
          quantity
          resolved
          subcategories {
            id
            name
            quantity
            resolved
          }
        }
      }
    }
  }
`

export const GET_FILTERS_OPTIONS_BY_ADMIN_MASTER_MAYOR = gql`
  mutation GetFiltersOptionsByAdminMasterMayor(
    $filters: filterOptionsInputAdminMasterMayor
  ) {
    getFiltersOptionsByAdminMasterMayor(filters: $filters) {
      years
      months {
        label
        value
      }
      weeks {
        label
        value
      }
    }
  }
`

export const EXPORTATION_ACTIVITY_REPORTS_COUNTERS = gql`
  mutation ExportActivityReportsCounters($filters: filterByExportation) {
    exportActivityReportsCounters(filters: $filters) {
      app
      canceled
      completed
      group_name
      pending
      sub_group_name
      tlajochat
      total
      web
    }
  }
`
export const GET_ACTIVITY_FOR_ROLE_ATENCION_CIUDADANA = gql`
  query GetActivitiReportsCountersForCitizenAttention(
    $filters: filtersForCitizenAttentionInput
  ) {
    getActivitiReportsCountersForCitizenAttention(filters: $filters) {
      averageCompleted
      app
      canceled
      completed
      name
      pending
      tlajochat
      total
      web
    }
  }
`
